// extracted by mini-css-extract-plugin
export var closeButton = "_fx-2";
export var closeButtonIcon = "_fx-3";
export var lightboxContent = "_fx-1";
export var lightboxOverlay = "_fx-0";